module.exports = __webpack_public_path__ + "static/media/background1.8eb48834.jpg";